module.exports = __webpack_public_path__ + "img/zhifubao.bc88e868.png";